
<template>
    <header
        :class="['header header--mobile hide--desktop', { 'no-bg' : isModal }]"
    >
        <router-link :to="{ name: 'home' }"><SVGlogo /></router-link>

        <Button display="link" class="close" @click="$emit('closeModal')" v-if="isModal"><SVGicon-x /></Button>
    </header>
</template>

<script>
export default {
    props: {
        isModal: {
            type: Boolean,
            default: false
        }
    }
}
</script>
